import { ClientRole, ManagerRole } from '~/constants/clientTypes';
import { TUserRole } from '~/store/users/types';

type TRefreshTokenPayload = {
  activeDirectoryScopes?: unknown;
  email?: unknown;
  groups?: unknown;
  roles?: unknown;
  sub?: string;
};

const CORPORATE_EMAIL_DOMAIN = 'eximb.com';
const managerRoles = new Set<string>(Object.values(ManagerRole));

const getStringList = (value: unknown): string[] =>
  Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : [];

const getKnownManagerRoles = (value: unknown): ManagerRole[] =>
  getStringList(value).filter((role): role is ManagerRole => managerRoles.has(role));

export const isCorporateManagerEmail = (email: unknown): boolean => {
  if (typeof email !== 'string') {
    return false;
  }

  const normalizedEmail = email.trim().toLowerCase();
  const atIndex = normalizedEmail.lastIndexOf('@');

  return (
    atIndex > 0 &&
    atIndex === normalizedEmail.indexOf('@') &&
    normalizedEmail.slice(atIndex + 1) === CORPORATE_EMAIL_DOMAIN
  );
};

export const resolveRefreshSession = (payload: TRefreshTokenPayload) => {
  const clientRoles = getStringList(payload.roles) as ClientRole[];
  const managerScopes = getKnownManagerRoles(payload.activeDirectoryScopes);
  const managerGroups = getKnownManagerRoles(payload.groups);
  const resolvedManagerRoles = managerScopes.length > 0 ? managerScopes : managerGroups;
  const isClientLogin = clientRoles.length > 0;

  return {
    email: typeof payload.email === 'string' ? payload.email.trim() : '',
    username: payload.sub || '',
    roles: (isClientLogin ? clientRoles : resolvedManagerRoles) as TUserRole,
    isClientLogin,
    isManagerLogin:
      !isClientLogin &&
      (resolvedManagerRoles.length > 0 || isCorporateManagerEmail(payload.email)),
  };
};
